module.exports = __webpack_public_path__ + "img/album18_21.7350a5db.jpg";